/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

const Constants = {
  // esignHandler esignStatuses (from DocumentsLib, ESignDocumentsConstants.java)
  
  // these 6 are used on client side
  ESIGN_STATUS_DECLINED: "declined",
  ESIGN_STATUS_LOCKED: "locked",
  ESIGN_STATUS_VOIDED: "voided",
  ESIGN_STATUS_SAVED: "saved",
  ESIGN_STATUS_COMPLETED: "completed",
  ESIGN_STATUS_DELIVERED: "delivered",
  // unused on clientside
  ESIGN_STATUS_CREATED: "created",
  ESIGN_STATUS_REQUESTED: "requested",
  ESIGN_STATUS_SENT: "sent",

  // esignHandler requests (from DocumentsLib, ESignDocumentsConstants.java)
  REQUEST_COMPLETED: "completed",
  REQUEST_DECLINED: "declined",
  REQUEST_LOCKED: "locked",
  REQUEST_OPENED: "opened",
  REQUEST_SAVED: "saved",

  GET_TEMPLATES: "getTemplateList",
  DELETE_TEMPLATE: "deleteTemplate",
  CREATE_ENVELOPE: "createEnvelope",
  GET_ENVELOPES: "getEnvelopeList",
  GET_ENVELOPE: "getEnvelope",
  EDIT_RECIPIENT: "editRecipient",
  DELETE_RECIPIENT: "deleteRecipient",
  RESEND_RECIPIENT: "resendRecipient",
  RESEND_ENVELOPE: "resendEnvelope",
  DELETE_ENVELOPE: "deleteEnvelope",
  VOID_ENVELOPE: "voidEnvelope",
  GET_TEMPLATE: "getTemplate",
  GET_ENVELOPE_HISTORY: "EnvelopeHistory",
  GET_GROUPS: "getGroups",
  GET_USERS: "getUsers",
  DELETE_USER: "DeleteUser",
  ADD_USER: "addUser",
  EDIT_USER: "updateAccessLevel",
  CREATE_BULK_ENVELOPE: "createBulkEnvelope",
  GET_ESIGN_STATUS_LIST: "getEsignStatusList",

  // minimum screen width for non-mobile view
  MIN_NON_MOBILE_WIDTH: "768",
};

export default Constants;
